interface CustomRowProps {
  children: React.ReactNode;
  className?: string;
  flexible?: boolean;
  responsiveCol?: boolean;
  mainAxisAlignment?: 'start' | 'center' | 'end' | 'between' | 'around' | 'evenly';
  crossAxisAlignment?: 'start' | 'center' | 'end' | 'stretch';
}

type RowProps = CustomRowProps & React.HTMLAttributes<HTMLDivElement>;

export const Row = ({
  children,
  className = '',
  flexible = false,
  responsiveCol = false,
  mainAxisAlignment = 'start',
  crossAxisAlignment = 'stretch',
  ...props
}: RowProps) => {
  const mainAxisClasses = {
    start: 'justify-start',
    center: 'justify-center',
    end: 'justify-end',
    between: 'justify-between',
    around: 'justify-around',
    evenly: 'justify-evenly',
  };

  const crossAxisClasses = {
    start: 'items-start',
    center: 'items-center',
    end: 'items-end',
    stretch: 'items-stretch',
  };
  const mainAxisClass = mainAxisClasses[mainAxisAlignment];
  const crossAxisClass = crossAxisClasses[crossAxisAlignment];

  return (
    <div
      className={`${
         `flex ${responsiveCol?`flex-col md:flex-row gap-2`:`flex-row ${mainAxisClass} ${crossAxisClass}`}`
      } ${!flexible ? 'w-full' : ''} ${className}`}
      {...props}
    >
      {children}
    </div>
  );
};
